export const TICKER_CATEGORY = {
  TOP: 'TOP',
  CRYPTO: 'CRYPTO',
  FOREX: 'FOREX',
  COMMODITIES: 'COMMODITIES',
  INDICES: 'INDICES',
  FAVORITES: 'FAVORITES',
};

export const TICKERS_CATEGORIES = {
  [TICKER_CATEGORY.TOP]: {
    label: 'Top instruments',
    symbols: [
      'EURUSD',
      'GBPUSD',
      'XRPUSD',
      'BTCUSD',
      'ADAUSD',
      'ETHUSD',
      'EU50',
      'XAUUSD',
      'XPDUSD',
      'AUDJPY',
      'UK100',
      'US100',
      'EURCHF',
      'EURJPY',
      'USDCHF',
      'USDJPY',
      'USDCAD',
      'AUDUSD',
    ],
  },
  [TICKER_CATEGORY.INDICES]: {
    label: 'Indices',
    symbols: [
      'AUS200',
      'US500',
      'CHNIND',
      'EU50',
      'FRA40',
      'GER30',
      'HKIND',
      'ITA40',
      'SPA35',
      'UK100',
      'US100',
      'US30',
      'JAP225',
      'MEXIND',
      'RUS50',
      'SUI20',
      'US2000',
      'VIX',
    ],
  },
  [TICKER_CATEGORY.FOREX]: {
    label: 'Forex',
    symbols: [
      'EURUSD',
      'GBPUSD',
      'USDCHF',
      'USDJPY',
      'USDCAD',
      'AUDUSD',
      'AUDNZD',
      'AUDCAD',
      'AUDCHF',
      'AUDJPY',
      'CHFJPY',
      'EURGBP',
      'EURAUD',
      'EURCHF',
      'EURJPY',
      'EURNZD',
      'EURCAD',
      'GBPCHF',
      'CADCHF',
      'CADJPY',
      'GBPAUD',
      'GBPCAD',
      'GBPNZD',
      'NZDCAD',
      'NZDCHF',
      'NZDJPY',
      'NZDUSD',
      'USDHKD',
      'EURCZK',
      'EURHUF',
      'EURNOK',
      'EURPLN',
      'EURSEK',
      'EURTRY',
      'USDCZK',
      'USDHUF',
      'USDMXN',
      'USDNOK',
      'USDPLN',
      'USDSEK',
    ],
  },
  [TICKER_CATEGORY.COMMODITIES]: {
    label: 'Commodities',
    symbols: [
      'XAGUSD',
      'XAUUSD',
      'XPDUSD',
      'XPTUSD',
      'WHEAT',
      'SUGAR',
      'ALUMINIUM',
      'COPPER',
      'ZINC',
      'WTI',
    ],
  },
  [TICKER_CATEGORY.CRYPTO]: {
    label: 'Crypto',
    symbols: [
      'ETHUSD',
      'LTCUSD',
      'ADAUSD',
      'DOTUSD',
      'XLMUSD',
      'XRPUSD',
      'BTCUSD',
      'BCHUSD',
      'BSVUSD',
      'DOGUSD',
      'EOSUSD',
      'LNKUSD',
      'LTCBTC',
      'THTUSD',
      'TRXUSD',
      'UNIUSD',
      'VETUSD',
      'XTZUSD',
      'AVEUSD',
    ],
  },
  [TICKER_CATEGORY.FAVORITES]: {
    label: 'My favorites',
    symbols: [],
  },
};
